import Context from "../../context/Context";

export function queryFieldValue(source, url, field, value, isObjectId, gdbVersion) {
  if (typeof value === undefined || value === null) {
    return Promise.resolve(null);
  }
  const lib = Context.getInstance().lib;
  url = Context.checkMixedContent(url);
  const task = new lib.esri.QueryTask({url: url});
  const query = new lib.esri.Query();
  query.outFields = ["*"];
  const view = Context.getInstance().views.mapView;
  if (view) query.outSpatialReference = view.spatialReference;
  query.returnGeometry = true;
  query.returnZ = true;
  query.multipatchOption = "xyFootprint";
  if (isObjectId) {
    query.objectIds = [value];
  } else {
    if (typeof field === "string" && field.toLowerCase() === "objectid") {
      query.where = field + " = " + value;
    } else if (typeof value === "string" ) {
      value = value.replace("'","''");
      query.where = field + " = '" + value + "'";
    } else {
      query.where = field + " = " + value;
    }
  }
  if (gdbVersion) query.gdbVersion = gdbVersion;
  const promise = task.execute(query);
  promise.then(result => {
    if (result && result.features && result.features.length === 1) {
      const feature: any = result.features[0];
      feature.xtnFields = result.fields;
      if (source) {
        feature.xtnSourceUrl = url;
        feature.xtnSource = source;
      }
    }
  });
  return promise;
}
